export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 30;
export const PASSWORD_MIN_LENGTH = 6;

export const REFRESH_TOKEN_INTERVAL = 60 * 60 * 1000;